type BrowserFileRecord = {
  blob: Blob;
  jobId: string;
};

const browserFiles = new Map<string, BrowserFileRecord>();

export function registerBrowserPostFile(jobId: string, blob: Blob) {
  const uri = URL.createObjectURL(blob);
  browserFiles.set(uri, { blob, jobId });
  return uri;
}

export function getBrowserPostFile(uri: string) {
  return browserFiles.get(uri)?.blob ?? null;
}

export function releaseBrowserPostFile(uri: string) {
  if (!browserFiles.delete(uri)) return;
  URL.revokeObjectURL(uri);
}

export function releaseBrowserPostJob(jobId: string) {
  for (const [uri, record] of browserFiles) {
    if (record.jobId === jobId) releaseBrowserPostFile(uri);
  }
}
